// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import logo from '../assets/coreopsai.png';
// import HRMSImage from '../assets/hrms.jpg';
// import { backend_url } from '../config';

// function SignUp() {
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [message, setMessage] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [activeField, setActiveField] = useState(null);
//   const [animateCard, setAnimateCard] = useState(false);
//   const navigate = useNavigate();

//   // Apply entrance animation when component mounts
//   useEffect(() => {
//     setAnimateCard(true);
//   }, []);

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       const response = await axios.post(`${backend_url}/register`, {
//         name,
//         email,
//         password,
//       });

//       if (response.status === 201) {
//         setMessage('Registration Successful. Please verify your email.');
//         setTimeout(() => {
//           navigate('/signin'); // Redirect to sign-in after successful registration
//         }, 2000);
//       } else {
//         setError('Registration failed. Please try again.');
//       }
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//           'Registration failed. Please check your details.'
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Add animated field highlight
//   const handleFocus = (field) => {
//     setActiveField(field);
//   };

//   const handleBlur = () => {
//     setActiveField(null);
//   };

//   // Inline styles
//   const styles = {
//     signinPageContainer: {
//       display: 'flex',
//       height: '100vh',
//       width: '100%',
//       overflow: 'hidden',
//       position: 'relative',
//     },
//     imageContainer: {
//       flex: '1',
//       overflow: 'hidden',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//     },
//     hrmsImage: {
//       width: '100%',
//       height: '100%',
//       objectFit: 'cover',
//     },
//     authContainer: {
//       flex: '1',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '2rem',
//       background: '#f8f9fa',
//     },
//     authCard: {
//       width: '100%',
//       maxWidth: '450px',
//       background: 'white',
//       borderRadius: '12px',
//       boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
//       padding: '2rem',
//       transition: 'all 0.3s ease',
//       transform: 'translateY(20px)',
//       opacity: '0',
//     },
//     cardAnimated: {
//       transform: 'translateY(0)',
//       opacity: '1',
//     },
//     authHeader: {
//       textAlign: 'center',
//       marginBottom: '2rem',
//     },
//     logoImage: {
//       height: '60px',
//       marginBottom: '1rem',
//     },
//     logoPulse: {
//       animation: 'pulse 2s infinite',
//     },
//     authTitle: {
//       fontSize: '1.8rem',
//       fontWeight: '600',
//       color: '#333',
//       margin: '0',
//     },
//     errorMessage: {
//       background: '#ffe6e6',
//       color: '#d32f2f',
//       padding: '0.8rem',
//       borderRadius: '6px',
//       marginBottom: '1.5rem',
//       fontSize: '0.9rem',
//       textAlign: 'center',
//     },
//     successMessage: {
//       background: '#e6ffed',
//       color: '#2e7d32',
//       padding: '0.8rem',
//       borderRadius: '6px',
//       marginBottom: '1.5rem',
//       fontSize: '0.9rem',
//       textAlign: 'center',
//     },
//     authForm: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '1.5rem',
//     },
//     formGroup: {
//       position: 'relative',
//       transition: 'all 0.3s ease',
//     },
//     activeField: {
//       transform: 'translateY(-4px)',
//     },
//     label: {
//       position: 'absolute',
//       left: '12px',
//       top: '12px',
//       color: '#666',
//       fontSize: '1rem',
//       pointerEvents: 'none',
//       transition: 'all 0.2s ease',
//       background: 'white',
//       padding: '0 4px',
//     },
//     hasValue: {
//       top: '-10px',
//       left: '12px',
//       fontSize: '0.85rem',
//       color: '#3f51b5',
//     },
//     formInput: {
//       width: '100%',
//       padding: '12px',
//       fontSize: '1rem',
//       border: '1px solid #ddd',
//       borderRadius: '8px',
//       outline: 'none',
//       transition: 'all 0.3s ease',
//     },
//     passwordStrength: {
//       marginTop: '8px',
//       height: '4px',
//       borderRadius: '2px',
//       overflow: 'hidden',
//       backgroundColor: '#f0f0f0',
//     },
//     strengthMeter: {
//       height: '100%',
//       transition: 'all 0.3s ease',
//     },
//     strengthWeak: {
//       width: '30%',
//       backgroundColor: '#f44336',
//     },
//     strengthMedium: {
//       width: '70%',
//       backgroundColor: '#ff9800',
//     },
//     strengthStrong: {
//       width: '100%',
//       backgroundColor: '#4caf50',
//     },
//     submitButton: {
//       padding: '12px',
//       fontSize: '1rem',
//       background: '#3f51b5',
//       color: 'white',
//       border: 'none',
//       borderRadius: '8px',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '0.5rem',
//       marginTop: '1rem',
//     },
//     loading: {
//       backgroundColor: '#3949ab',
//       pointerEvents: 'none',
//     },
//     spinner: {
//       width: '20px',
//       height: '20px',
//       border: '3px solid rgba(255, 255, 255, 0.3)',
//       borderTop: '3px solid white',
//       borderRadius: '50%',
//       animation: 'spin 1s linear infinite',
//     },
//     authFooter: {
//       marginTop: '1.5rem',
//       textAlign: 'center',
//       fontSize: '0.9rem',
//       color: '#666',
//     },
//     signinLink: {
//       color: '#3f51b5',
//       textDecoration: 'none',
//       fontWeight: '600',
//       transition: 'all 0.2s ease',
//     },
//   };

//   // Add keyframe animations as a style tag
//   const keyframeStyles = `
//     @keyframes pulse {
//       0% { transform: scale(1); }
//       50% { transform: scale(1.05); }
//       100% { transform: scale(1); }
//     }

//     @keyframes spin {
//       0% { transform: rotate(0deg); }
//       100% { transform: rotate(360deg); }
//     }
//   `;

//   return (
//     <>
//       <style>{keyframeStyles}</style>
//       <div style={styles.signinPageContainer}>
//         <div style={styles.imageContainer}>
//           <img src={HRMSImage} alt='HRMS' style={styles.hrmsImage} />
//         </div>

//         <div style={styles.authContainer}>
//           <div
//             style={{
//               ...styles.authCard,
//               ...(animateCard ? styles.cardAnimated : {}),
//             }}
//           >
//             <div style={styles.authHeader}>
//               <img
//                 src={logo}
//                 alt='CoreOpsAI'
//                 style={{ ...styles.logoImage, ...styles.logoPulse }}
//               />
//               <h2 style={styles.authTitle}>Sign Up</h2>
//             </div>

//             {error && (
//               <div style={styles.errorMessage}>
//                 <span>{error}</span>
//               </div>
//             )}

//             {message && (
//               <div style={styles.successMessage}>
//                 <span>{message}</span>
//               </div>
//             )}

//             <form onSubmit={handleSubmit} style={styles.authForm}>
//               <div
//                 style={{
//                   ...styles.formGroup,
//                   ...(activeField === 'name' ? styles.activeField : {}),
//                 }}
//               >
//                 <label
//                   htmlFor='name'
//                   style={{
//                     ...styles.label,
//                     ...(name ? styles.hasValue : {}),
//                     ...(activeField === 'name' ? { color: '#3f51b5' } : {}),
//                   }}
//                 >
//                   Full Name
//                 </label>
//                 <input
//                   type='text'
//                   id='name'
//                   style={{
//                     ...styles.formInput,
//                     ...(activeField === 'name'
//                       ? { borderColor: '#3f51b5' }
//                       : {}),
//                   }}
//                   value={name}
//                   onChange={(e) => setName(e.target.value)}
//                   onFocus={() => handleFocus('name')}
//                   onBlur={handleBlur}
//                   required
//                 />
//               </div>

//               <div
//                 style={{
//                   ...styles.formGroup,
//                   ...(activeField === 'email' ? styles.activeField : {}),
//                 }}
//               >
//                 <label
//                   htmlFor='email'
//                   style={{
//                     ...styles.label,
//                     ...(email ? styles.hasValue : {}),
//                     ...(activeField === 'email' ? { color: '#3f51b5' } : {}),
//                   }}
//                 >
//                   Email Address
//                 </label>
//                 <input
//                   type='email'
//                   id='email'
//                   style={{
//                     ...styles.formInput,
//                     ...(activeField === 'email'
//                       ? { borderColor: '#3f51b5' }
//                       : {}),
//                   }}
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   onFocus={() => handleFocus('email')}
//                   onBlur={handleBlur}
//                   required
//                 />
//               </div>

//               <div
//                 style={{
//                   ...styles.formGroup,
//                   ...(activeField === 'password' ? styles.activeField : {}),
//                 }}
//               >
//                 <label
//                   htmlFor='password'
//                   style={{
//                     ...styles.label,
//                     ...(password ? styles.hasValue : {}),
//                     ...(activeField === 'password' ? { color: '#3f51b5' } : {}),
//                   }}
//                 >
//                   Password
//                 </label>
//                 <input
//                   type='password'
//                   id='password'
//                   style={{
//                     ...styles.formInput,
//                     ...(activeField === 'password'
//                       ? { borderColor: '#3f51b5' }
//                       : {}),
//                   }}
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   onFocus={() => handleFocus('password')}
//                   onBlur={handleBlur}
//                   required
//                 />
//                 {password && (
//                   <div style={styles.passwordStrength}>
//                     <div
//                       style={{
//                         ...styles.strengthMeter,
//                         ...(password.length < 6
//                           ? styles.strengthWeak
//                           : password.length < 8
//                           ? styles.strengthMedium
//                           : styles.strengthStrong),
//                       }}
//                     ></div>
//                   </div>
//                 )}
//               </div>

//               <button
//                 type='submit'
//                 style={{
//                   ...styles.submitButton,
//                   ...(loading ? styles.loading : {}),
//                 }}
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <>
//                     <div style={styles.spinner}></div>
//                     <span>Processing...</span>
//                   </>
//                 ) : (
//                   <span>Register</span>
//                 )}
//               </button>
//             </form>

//             <div style={styles.authFooter}>
//               <p>
//                 Already have an account?{' '}
//                 <Link to='/signin' style={styles.signinLink}>
//                   Sign In
//                 </Link>
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default SignUp;


////////////////////////////



// import React, { useState, useEffect, useMemo } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import logo from '../assets/coreopsai.png';
// import HRMSImage from '../assets/hrms.jpg';
// import { backend_url } from '../config';

// /* ------------------------------------------------------------------ */
// /*  Password strength — length + character variety, not length alone   */
// /* ------------------------------------------------------------------ */
// function scorePassword(pw) {
//   if (!pw) return { score: 0, label: '', hint: '' };
//   let score = 0;
//   if (pw.length >= 8) score++;
//   if (pw.length >= 12) score++;
//   if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
//   if (/\d/.test(pw)) score++;
//   if (/[^A-Za-z0-9]/.test(pw)) score++;

//   if (score <= 1) return { score: 1, label: 'Weak', hint: 'Use 8+ characters with a mix of letters and numbers' };
//   if (score <= 3) return { score: 2, label: 'Good', hint: 'Add a symbol or more length to strengthen it' };
//   return { score: 3, label: 'Strong', hint: 'Great password' };
// }

// function SignUp() {
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState('');
//   const [message, setMessage] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [mounted, setMounted] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     setMounted(true);
//   }, []);

//   const strength = useMemo(() => scorePassword(password), [password]);
//   const formValid = name.trim() && email.trim() && password.length >= 8;

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     if (!formValid || loading) return;
//     setError('');
//     setLoading(true);

//     try {
//       const response = await axios.post(`${backend_url}/register`, {
//         name: name.trim(),
//         email: email.trim(),
//         password,
//       });

//       if (response.status === 201) {
//         setMessage('Account created. Check your inbox to verify your email — redirecting you to sign in.');
//         setTimeout(() => navigate('/signin'), 2500);
//       } else {
//         setError('Registration failed. Please try again.');
//       }
//     } catch (err) {
//       setError(
//         err.response?.data?.message ||
//         'Registration failed. Please check your details and try again.'
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <style>{css}</style>
//       <div className={`su-page ${mounted ? 'su-mounted' : ''}`}>
//         {/* ---------------- Brand panel ---------------- */}
//         <aside className="su-brand" aria-hidden="true">
//           <div className="su-brand-img-wrap">
//             <img src={HRMSImage} alt="" className="su-brand-img" />
//           </div>
//           <div className="su-brand-overlay" />

//           {/* Signature: org-lattice — people nodes connecting */}
//           <svg className="su-lattice" viewBox="0 0 480 480" fill="none">
//             <g className="su-lattice-lines" stroke="currentColor" strokeWidth="1">
//               <path d="M240 90 L120 210 M240 90 L360 210 M120 210 L120 340 M360 210 L360 340 M120 210 L240 260 M360 210 L240 260 M240 260 L240 400" />
//             </g>
//             <g className="su-lattice-nodes" fill="currentColor">
//               <circle cx="240" cy="90" r="7" className="su-node su-node-1" />
//               <circle cx="120" cy="210" r="6" className="su-node su-node-2" />
//               <circle cx="360" cy="210" r="6" className="su-node su-node-3" />
//               <circle cx="240" cy="260" r="6" className="su-node su-node-4" />
//               <circle cx="120" cy="340" r="5" className="su-node su-node-5" />
//               <circle cx="360" cy="340" r="5" className="su-node su-node-6" />
//               <circle cx="240" cy="400" r="5" className="su-node su-node-7" />
//             </g>
//           </svg>

//           <div className="su-brand-content">
//             <img src={logo} alt="CoreOpsAI" className="su-brand-logo" />
//             <h1 className="su-brand-headline">
//               Every person,
//               <br />
//               one system.
//             </h1>
//             <p className="su-brand-sub">
//               Onboarding, attendance, payroll, and performance — managed from a
//               single place, so your team can focus on the work.
//             </p>
//           </div>
//         </aside>

//         {/* ---------------- Form panel ---------------- */}
//         <main className="su-form-panel">
//           <div className="su-form-inner">
//             <header className="su-form-header">
//               <img src={logo} alt="CoreOpsAI" className="su-form-logo" />
//               <h2 className="su-form-title">Create your account</h2>
//               <p className="su-form-sub">Start managing your workforce in minutes.</p>
//             </header>

//             {error && (
//               <div className="su-alert su-alert-error" role="alert">
//                 {error}
//               </div>
//             )}
//             {message && (
//               <div className="su-alert su-alert-success" role="status">
//                 {message}
//               </div>
//             )}

//             <form onSubmit={handleSubmit} className="su-form" noValidate>
//               <div className="su-field">
//                 <label htmlFor="name" className="su-label">
//                   Full name
//                 </label>
//                 <input
//                   id="name"
//                   type="text"
//                   className="su-input"
//                   placeholder="your name"
//                   autoComplete="name"
//                   value={name}
//                   onChange={(e) => setName(e.target.value)}
//                   required
//                 />
//               </div>

//               <div className="su-field">
//                 <label htmlFor="email" className="su-label">
//                   Work email
//                 </label>
//                 <input
//                   id="email"
//                   type="email"
//                   className="su-input"
//                   placeholder="first_name@company.com"
//                   autoComplete="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   required
//                 />
//               </div>

//               <div className="su-field">
//                 <div className="su-label-row">
//                   <label htmlFor="password" className="su-label">
//                     Password
//                   </label>
//                   {password && (
//                     <span className={`su-strength-label su-strength-${strength.score}`}>
//                       {strength.label}
//                     </span>
//                   )}
//                 </div>
//                 <div className="su-input-wrap">
//                   <input
//                     id="password"
//                     type={showPassword ? 'text' : 'password'}
//                     className="su-input"
//                     placeholder="At least 8 characters"
//                     autoComplete="new-password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                     minLength={8}
//                     aria-describedby="password-hint"
//                   />
//                   <button
//                     type="button"
//                     className="su-toggle-pw"
//                     onClick={() => setShowPassword((s) => !s)}
//                     aria-label={showPassword ? 'Hide password' : 'Show password'}
//                   >
//                     {showPassword ? 'Hide' : 'Show'}
//                   </button>
//                 </div>
//                 <div className="su-strength-track" aria-hidden="true">
//                   <div className={`su-strength-bar su-strength-${strength.score}`} />
//                 </div>
//                 <p id="password-hint" className="su-hint">
//                   {password ? strength.hint : 'Use 8+ characters with a mix of letters, numbers, and symbols.'}
//                 </p>
//               </div>

//               <button
//                 type="submit"
//                 className="su-submit"
//                 disabled={loading || !formValid}
//               >
//                 {loading ? (
//                   <>
//                     <span className="su-spinner" aria-hidden="true" />
//                     Creating account…
//                   </>
//                 ) : (
//                   'Create account'
//                 )}
//               </button>
//             </form>

//             <p className="su-footer">
//               Already have an account?{' '}
//               <Link to="/signin" className="su-link">
//                 Sign in
//               </Link>
//             </p>
//           </div>
//         </main>
//       </div>
//     </>
//   );
// }

// /* ------------------------------------------------------------------ */
// /*  Styles                                                             */
// /* ------------------------------------------------------------------ */
// const css = `
// @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,500;12..96,700&family=Inter:wght@400;500;600&display=swap');

// .su-page {
//   --ink: #0E1420;
//   --ink-soft: #3A4356;
//   --porcelain: #F5F6FA;
//   --line: #DDE1EA;
//   --indigo: #4353FF;
//   --indigo-deep: #2F3BD4;
//   --teal: #17C3A2;
//   --amber: #E8A13D;
//   --red: #D64545;
//   --font-display: 'Bricolage Grotesque', 'Segoe UI', sans-serif;
//   --font-body: 'Inter', -apple-system, 'Segoe UI', sans-serif;

//   display: flex;
//   min-height: 100vh;
//   width: 100%;
//   font-family: var(--font-body);
//   color: var(--ink);
//   background: var(--porcelain);
// }

// /* ---------------- Brand panel ---------------- */
// .su-brand {
//   position: relative;
//   flex: 1 1 48%;
//   background: var(--ink);
//   overflow: hidden;
//   display: flex;
//   align-items: flex-end;
// }
// .su-brand-img-wrap { position: absolute; inset: 0; }
// .su-brand-img {
//   width: 100%; height: 100%;
//   object-fit: cover;
//   opacity: 0.28;
//   filter: grayscale(100%) contrast(1.05);
// }
// .su-brand-overlay {
//   position: absolute; inset: 0;
//   background: linear-gradient(160deg, rgba(14,20,32,0.55) 0%, rgba(14,20,32,0.92) 70%),
//               linear-gradient(0deg, rgba(67,83,255,0.16), rgba(67,83,255,0.16));
// }
// .su-lattice {
//   position: absolute;
//   top: -40px; right: -60px;
//   width: 420px; height: 420px;
//   color: rgba(255,255,255,0.5);
// }
// .su-lattice-lines { opacity: 0.35; }
// .su-node { opacity: 0; animation: su-node-in 700ms ease forwards; }
// .su-node-1 { animation-delay: 200ms; }
// .su-node-2 { animation-delay: 350ms; }
// .su-node-3 { animation-delay: 450ms; }
// .su-node-4 { animation-delay: 600ms; }
// .su-node-5 { animation-delay: 750ms; }
// .su-node-6 { animation-delay: 850ms; }
// .su-node-7 { animation-delay: 1000ms; }
// @keyframes su-node-in {
//   from { opacity: 0; transform: scale(0.4); transform-origin: center; transform-box: fill-box; }
//   to   { opacity: 1; transform: scale(1);   transform-origin: center; transform-box: fill-box; }
// }

// .su-brand-content {
//   position: relative;
//   padding: 4rem 4rem 4.5rem;
//   max-width: 560px;
//   color: #fff;
// }
// .su-brand-logo {
//   height: 44px;
//   margin-bottom: 2.5rem;
//   filter: brightness(0) invert(1);
// }
// .su-brand-headline {
//   font-family: var(--font-display);
//   font-weight: 700;
//   font-size: clamp(2.4rem, 4vw, 3.4rem);
//   line-height: 1.05;
//   letter-spacing: -0.02em;
//   margin: 0 0 1.25rem;
// }
// .su-brand-sub {
//   font-size: 1.05rem;
//   line-height: 1.6;
//   color: rgba(255,255,255,0.72);
//   margin: 0;
//   max-width: 42ch;
// }

// /* ---------------- Form panel ---------------- */
// .su-form-panel {
//   flex: 1 1 52%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   padding: 3rem 2rem;
// }
// .su-form-inner {
//   width: 100%;
//   max-width: 400px;
//   opacity: 0;
//   transform: translateY(14px);
//   transition: opacity 500ms ease, transform 500ms ease;
// }
// .su-mounted .su-form-inner { opacity: 1; transform: translateY(0); }

// .su-form-logo { display: none; height: 40px; margin-bottom: 1.5rem; }
// .su-form-title {
//   font-family: var(--font-display);
//   font-weight: 700;
//   font-size: 1.9rem;
//   letter-spacing: -0.015em;
//   margin: 0 0 0.4rem;
// }
// .su-form-sub { color: var(--ink-soft); font-size: 0.95rem; margin: 0 0 2rem; }

// .su-alert {
//   padding: 0.85rem 1rem;
//   border-radius: 10px;
//   font-size: 0.9rem;
//   line-height: 1.45;
//   margin-bottom: 1.4rem;
//   border: 1px solid transparent;
// }
// .su-alert-error   { background: #FCEEEE; color: #9E2B2B; border-color: #F2CFCF; }
// .su-alert-success { background: #E9F9F4; color: #0E7A64; border-color: #C4EDE1; }

// .su-form { display: flex; flex-direction: column; gap: 1.35rem; }
// .su-field { display: flex; flex-direction: column; }
// .su-label-row { display: flex; justify-content: space-between; align-items: baseline; }
// .su-label {
//   font-size: 0.84rem;
//   font-weight: 600;
//   letter-spacing: 0.01em;
//   margin-bottom: 0.45rem;
//   color: var(--ink);
// }
// .su-input-wrap { position: relative; }
// .su-input {
//   width: 100%;
//   padding: 0.8rem 0.95rem;
//   font-size: 0.98rem;
//   font-family: var(--font-body);
//   color: var(--ink);
//   background: #fff;
//   border: 1.5px solid var(--line);
//   border-radius: 10px;
//   outline: none;
//   transition: border-color 160ms ease, box-shadow 160ms ease;
//   box-sizing: border-box;
// }
// .su-input::placeholder { color: #A7AFC0; }
// .su-input:hover { border-color: #C3C9D6; }
// .su-input:focus {
//   border-color: var(--indigo);
//   box-shadow: 0 0 0 3px rgba(67,83,255,0.14);
// }
// .su-toggle-pw {
//   position: absolute;
//   right: 0.6rem; top: 50%;
//   transform: translateY(-50%);
//   border: none;
//   background: none;
//   font: 600 0.78rem var(--font-body);
//   color: var(--ink-soft);
//   cursor: pointer;
//   padding: 0.35rem 0.5rem;
//   border-radius: 6px;
// }
// .su-toggle-pw:hover { color: var(--indigo); background: rgba(67,83,255,0.07); }

// .su-strength-track {
//   height: 4px;
//   border-radius: 2px;
//   background: var(--line);
//   margin-top: 0.6rem;
//   overflow: hidden;
// }
// .su-strength-bar { height: 100%; width: 0; border-radius: 2px; transition: width 300ms ease, background 300ms ease; }
// .su-strength-bar.su-strength-1 { width: 33%;  background: var(--red); }
// .su-strength-bar.su-strength-2 { width: 66%;  background: var(--amber); }
// .su-strength-bar.su-strength-3 { width: 100%; background: var(--teal); }
// .su-strength-label { font-size: 0.76rem; font-weight: 600; }
// .su-strength-label.su-strength-1 { color: var(--red); }
// .su-strength-label.su-strength-2 { color: #B57A1E; }
// .su-strength-label.su-strength-3 { color: #0E8A72; }
// .su-hint { font-size: 0.78rem; color: var(--ink-soft); margin: 0.45rem 0 0; line-height: 1.4; }

// .su-submit {
//   margin-top: 0.4rem;
//   padding: 0.9rem 1rem;
//   font: 600 1rem var(--font-body);
//   color: #fff;
//   background: var(--indigo);
//   border: none;
//   border-radius: 10px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 0.6rem;
//   transition: background 160ms ease, transform 120ms ease, box-shadow 160ms ease;
// }
// .su-submit:hover:not(:disabled) {
//   background: var(--indigo-deep);
//   box-shadow: 0 6px 18px rgba(67,83,255,0.28);
//   transform: translateY(-1px);
// }
// .su-submit:active:not(:disabled) { transform: translateY(0); }
// .su-submit:disabled { opacity: 0.55; cursor: not-allowed; }
// .su-submit:focus-visible,
// .su-input:focus-visible,
// .su-toggle-pw:focus-visible,
// .su-link:focus-visible {
//   outline: 2px solid var(--indigo);
//   outline-offset: 2px;
// }

// .su-spinner {
//   width: 18px; height: 18px;
//   border: 2.5px solid rgba(255,255,255,0.35);
//   border-top-color: #fff;
//   border-radius: 50%;
//   animation: su-spin 0.8s linear infinite;
// }
// @keyframes su-spin { to { transform: rotate(360deg); } }

// .su-footer {
//   margin-top: 1.8rem;
//   text-align: center;
//   font-size: 0.9rem;
//   color: var(--ink-soft);
// }
// .su-link { color: var(--indigo); font-weight: 600; text-decoration: none; }
// .su-link:hover { text-decoration: underline; }

// /* ---------------- Responsive ---------------- */
// @media (max-width: 900px) {
//   .su-brand { display: none; }
//   .su-form-logo { display: block; }
//   .su-form-panel { padding: 2.5rem 1.5rem; }
// }

// /* ---------------- Reduced motion ---------------- */
// @media (prefers-reduced-motion: reduce) {
//   .su-form-inner { transition: none; opacity: 1; transform: none; }
//   .su-node { animation: none; opacity: 1; }
//   .su-strength-bar, .su-input, .su-submit { transition: none; }
// }
// `;

// export default SignUp;


/////////////////////////


import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/coreopsai.png';
import { backend_url } from '../config';

/* ------------------------------------------------------------------ */
/*  Password strength — length + character variety, not length alone   */
/* ------------------------------------------------------------------ */
function scorePassword(pw) {
  if (!pw) return { score: 0, label: '', hint: '' };
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;

  if (score <= 1) return { score: 1, label: 'Weak', hint: 'Use 8+ characters with a mix of letters and numbers' };
  if (score <= 3) return { score: 2, label: 'Good', hint: 'Add a symbol or more length to strengthen it' };
  return { score: 3, label: 'Strong', hint: 'Great password' };
}

/* ------------------------------------------------------------------ */
/*  Inline icons                                                       */
/* ------------------------------------------------------------------ */
const IconUser = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-3.3 3.6-5 8-5s8 1.7 8 5" />
  </svg>
);
const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="m4 7 8 6 8-6" />
  </svg>
);
const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4.5" y="10.5" width="15" height="9.5" rx="2.5" />
    <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" />
  </svg>
);

function SignUp() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [mounted, setMounted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setMounted(true);
  }, []);

  const strength = useMemo(() => scorePassword(password), [password]);
  const formValid = name.trim() && email.trim() && password.length >= 8;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formValid || loading) return;
    setError('');

    if (!email || !email.trim().toLowerCase().endsWith('@coreops.ai')) {
      setError('Registration restricted: Only users with a @coreops.ai email domain are allowed to register.');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${backend_url}/register`, {
        name: name.trim(),
        email: email.trim(),
        password,
      });

      if (response.status === 201) {
        setMessage('Account created. Check your inbox to verify your email — redirecting you to sign in.');
        setTimeout(() => navigate('/signin'), 2500);
      } else {
        setError('Registration failed. Please try again.');
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
        'Registration failed. Please check your details and try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{css}</style>
      <div className={`su-page ${mounted ? 'su-mounted' : ''}`}>
        {/* ---------------- Brand panel ---------------- */}
        <aside className="su-brand" aria-hidden="true">
          {/* Aurora blobs */}
          <div className="su-orb su-orb-1" />
          <div className="su-orb su-orb-2" />
          <div className="su-orb su-orb-3" />
          {/* Dot grid */}
          <div className="su-dotgrid" />

          <div className="su-brand-content">
            <img src={logo} alt="CoreOpsAI" className="su-brand-logo" />
            <h1 className="su-brand-headline">
              Every person,
              <br />
              one system.
            </h1>
            <p className="su-brand-sub">
              Onboarding, attendance, payroll, and performance — managed from a
              single place, so your team can focus on the work.
            </p>

            <div className="su-brand-stats">
              <div className="su-brand-stat">
                <span className="su-brand-stat-num">2 min</span>
                <span className="su-brand-stat-label">to onboard</span>
              </div>
              <div className="su-brand-stat-divider" />
              <div className="su-brand-stat">
                <span className="su-brand-stat-num">1 place</span>
                <span className="su-brand-stat-label">for HR data</span>
              </div>
              <div className="su-brand-stat-divider" />
              <div className="su-brand-stat">
                <span className="su-brand-stat-num">0 sheets</span>
                <span className="su-brand-stat-label">to maintain</span>
              </div>
            </div>
          </div>

          {/* -------- Floating dashboard cards (the graphical bit) -------- */}
          <div className="su-cards">
            {/* Attendance ring card */}
            <div className="su-card su-card-ring">
              <svg viewBox="0 0 96 96" className="su-ring">
                <circle cx="48" cy="48" r="38" className="su-ring-track" />
                <circle cx="48" cy="48" r="38" className="su-ring-fill" />
                <text x="48" y="45" textAnchor="middle" className="su-ring-num">96%</text>
                <text x="48" y="61" textAnchor="middle" className="su-ring-label">present</text>
              </svg>
              <div className="su-card-meta">
                <span className="su-card-title">Attendance</span>
                <span className="su-card-sub">Today · 142 of 148 in</span>
              </div>
            </div>

            {/* Payroll bars card */}
            <div className="su-card su-card-bars">
              <div className="su-card-meta">
                <span className="su-card-title">Payroll run</span>
                <span className="su-card-sub">Processed on time, 6 months straight</span>
              </div>
              <div className="su-bars">
                <span style={{ height: '38%' }} />
                <span style={{ height: '55%' }} />
                <span style={{ height: '46%' }} />
                <span style={{ height: '70%' }} />
                <span style={{ height: '62%' }} />
                <span className="su-bar-hot" style={{ height: '88%' }} />
              </div>
            </div>

            {/* New joiners card */}
            <div className="su-card su-card-people">
              <div className="su-avatars">
                <span className="su-avatar" style={{ background: '#7B5CFF' }}>AR</span>
                <span className="su-avatar" style={{ background: '#17C3A2' }}>PK</span>
                <span className="su-avatar" style={{ background: '#E8A13D' }}>SN</span>
                <span className="su-avatar su-avatar-more">+5</span>
              </div>
              <div className="su-card-meta">
                <span className="su-card-title">8 joining this week</span>
                <span className="su-card-sub">Onboarding auto-scheduled ✓</span>
              </div>
            </div>
          </div>
        </aside>

        {/* ---------------- Form panel ---------------- */}
        <main className="su-form-panel">
          <div className="su-form-bg" aria-hidden="true" />
          <div className="su-form-inner">
            <header className="su-form-header">
              <img src={logo} alt="CoreOpsAI" className="su-form-logo" />
              <h2 className="su-form-title">Create your account</h2>
              <p className="su-form-sub">Start managing your workforce in minutes.</p>
            </header>

            {error && (
              <div className="su-alert su-alert-error" role="alert">
                {error}
              </div>
            )}
            {message && (
              <div className="su-alert su-alert-success" role="status">
                {message}
              </div>
            )}

            <form onSubmit={handleSubmit} className="su-form" noValidate>
              <div className="su-field">
                <label htmlFor="name" className="su-label">
                  Full name
                </label>
                <div className="su-input-wrap">
                  <span className="su-input-icon"><IconUser /></span>
                  <input
                    id="name"
                    type="text"
                    className="su-input su-input-iconed"
                    placeholder="Priya Sharma"
                    autoComplete="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="su-field">
                <label htmlFor="email" className="su-label">
                  Work email
                </label>
                <div className="su-input-wrap">
                  <span className="su-input-icon"><IconMail /></span>
                  <input
                    id="email"
                    type="email"
                    className="su-input su-input-iconed"
                    placeholder="priya@company.com"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="su-field">
                <div className="su-label-row">
                  <label htmlFor="password" className="su-label">
                    Password
                  </label>
                  {password && (
                    <span className={`su-strength-label su-strength-${strength.score}`}>
                      {strength.label}
                    </span>
                  )}
                </div>
                <div className="su-input-wrap">
                  <span className="su-input-icon"><IconLock /></span>
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    className="su-input su-input-iconed"
                    placeholder="At least 8 characters"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={8}
                    aria-describedby="password-hint"
                  />
                  <button
                    type="button"
                    className="su-toggle-pw"
                    onClick={() => setShowPassword((s) => !s)}
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                  >
                    {showPassword ? 'Hide' : 'Show'}
                  </button>
                </div>
                <div className="su-strength-track" aria-hidden="true">
                  <div className={`su-strength-bar su-strength-${strength.score}`} />
                </div>
                <p id="password-hint" className="su-hint">
                  {password ? strength.hint : 'Use 8+ characters with a mix of letters, numbers, and symbols.'}
                </p>
              </div>

              <button
                type="submit"
                className="su-submit"
                disabled={loading || !formValid}
              >
                {loading ? (
                  <>
                    <span className="su-spinner" aria-hidden="true" />
                    Creating account…
                  </>
                ) : (
                  'Create account'
                )}
              </button>
            </form>

            <p className="su-footer">
              Already have an account?{' '}
              <Link to="/signin" className="su-link">
                Sign in
              </Link>
            </p>
          </div>
        </main>
      </div>
    </>
  );
}

/* ------------------------------------------------------------------ */
/*  Styles                                                             */
/* ------------------------------------------------------------------ */
const css = `
@import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,500;12..96,700&family=Inter:wght@400;500;600&display=swap');

.su-page {
  --ink: #0E1420;
  --ink-soft: #3A4356;
  --porcelain: #F5F6FA;
  --line: #DDE1EA;
  --indigo: #4353FF;
  --indigo-deep: #2F3BD4;
  --violet: #7B5CFF;
  --teal: #17C3A2;
  --amber: #E8A13D;
  --red: #D64545;
  --font-display: 'Bricolage Grotesque', 'Segoe UI', sans-serif;
  --font-body: 'Inter', -apple-system, 'Segoe UI', sans-serif;

  display: flex;
  min-height: 100vh;
  width: 100%;
  font-family: var(--font-body);
  color: var(--ink);
  background: var(--porcelain);
}

/* ---------------- Brand panel ---------------- */
.su-brand {
  position: relative;
  flex: 1 1 48%;
  background: radial-gradient(120% 120% at 15% 10%, #141C30 0%, #0E1420 55%, #0A0F1A 100%);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Aurora orbs */
.su-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.5;
  animation: su-drift 14s ease-in-out infinite alternate;
}
.su-orb-1 { width: 420px; height: 420px; top: -140px; left: -120px; background: var(--indigo); }
.su-orb-2 { width: 340px; height: 340px; bottom: -100px; right: -80px; background: var(--violet); animation-delay: -5s; }
.su-orb-3 { width: 240px; height: 240px; top: 42%; right: 18%; background: var(--teal); opacity: 0.28; animation-delay: -9s; }
@keyframes su-drift {
  from { transform: translate3d(0, 0, 0) scale(1); }
  to   { transform: translate3d(36px, -28px, 0) scale(1.12); }
}

/* Dot grid texture */
.su-dotgrid {
  position: absolute; inset: 0;
  background-image: radial-gradient(rgba(255,255,255,0.13) 1px, transparent 1px);
  background-size: 26px 26px;
  mask-image: radial-gradient(80% 70% at 50% 40%, #000 0%, transparent 100%);
  -webkit-mask-image: radial-gradient(80% 70% at 50% 40%, #000 0%, transparent 100%);
}

.su-brand-content {
  position: relative;
  padding: 3.5rem 4rem 0;
  max-width: 560px;
  color: #fff;
  z-index: 2;
}
.su-brand-logo {
  height: 44px;
  margin-bottom: 2.2rem;
  filter: brightness(0) invert(1);
}
.su-brand-headline {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: clamp(2.4rem, 4vw, 3.4rem);
  line-height: 1.05;
  letter-spacing: -0.02em;
  margin: 0 0 1.25rem;
  background: linear-gradient(100deg, #FFFFFF 30%, #AAB4FF 75%, #8FEEDC 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.su-brand-sub {
  font-size: 1.05rem;
  line-height: 1.6;
  color: rgba(255,255,255,0.72);
  margin: 0;
  max-width: 42ch;
}

.su-brand-stats {
  display: flex;
  align-items: center;
  gap: 1.4rem;
  margin-top: 2.2rem;
}
.su-brand-stat { display: flex; flex-direction: column; }
.su-brand-stat-num {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.35rem;
  color: #fff;
}
.su-brand-stat-label { font-size: 0.8rem; color: rgba(255,255,255,0.55); }
.su-brand-stat-divider { width: 1px; height: 34px; background: rgba(255,255,255,0.16); }

/* -------- Floating dashboard cards -------- */
.su-cards {
  position: relative;
  z-index: 2;
  padding: 2.5rem 4rem 3.5rem;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.1rem;
  max-width: 620px;
}
.su-card {
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.14);
  border-radius: 16px;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow: 0 18px 44px rgba(4,8,18,0.45);
  padding: 1.1rem 1.2rem;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 1rem;
  opacity: 0;
  transform: translateY(18px);
  animation: su-card-in 640ms cubic-bezier(0.22, 1, 0.36, 1) forwards,
             su-float 7s ease-in-out infinite alternate;
}
.su-card-ring   { animation-delay: 250ms, 1s; }
.su-card-bars   { animation-delay: 420ms, 2.4s; }
.su-card-people { grid-column: 1 / -1; animation-delay: 590ms, 3.6s; }
@keyframes su-card-in {
  to { opacity: 1; transform: translateY(0); }
}
@keyframes su-float {
  from { translate: 0 0; }
  to   { translate: 0 -7px; }
}

.su-card-meta { display: flex; flex-direction: column; gap: 0.2rem; min-width: 0; }
.su-card-title { font-weight: 600; font-size: 0.92rem; }
.su-card-sub { font-size: 0.76rem; color: rgba(255,255,255,0.6); line-height: 1.35; }

/* Attendance ring */
.su-ring { width: 76px; height: 76px; flex: 0 0 auto; }
.su-ring-track { fill: none; stroke: rgba(255,255,255,0.14); stroke-width: 8; }
.su-ring-fill {
  fill: none;
  stroke: var(--teal);
  stroke-width: 8;
  stroke-linecap: round;
  stroke-dasharray: 239;           /* 2πr ≈ 238.8 */
  stroke-dashoffset: 239;
  transform: rotate(-90deg);
  transform-origin: center;
  animation: su-ring-in 1.2s ease-out 600ms forwards;
}
@keyframes su-ring-in { to { stroke-dashoffset: 9.6; } } /* 96% */
.su-ring-num { font: 700 1.05rem var(--font-display); fill: #fff; }
.su-ring-label { font: 500 0.5rem var(--font-body); fill: rgba(255,255,255,0.6); letter-spacing: 0.08em; text-transform: uppercase; }

/* Payroll bars */
.su-card-bars { justify-content: space-between; }
.su-bars {
  display: flex;
  align-items: flex-end;
  gap: 5px;
  height: 58px;
  flex: 0 0 auto;
}
.su-bars span {
  width: 9px;
  border-radius: 4px 4px 2px 2px;
  background: rgba(255,255,255,0.28);
  transform-origin: bottom;
  animation: su-bar-in 700ms cubic-bezier(0.22, 1, 0.36, 1) backwards;
}
.su-bars span:nth-child(1) { animation-delay: 700ms; }
.su-bars span:nth-child(2) { animation-delay: 780ms; }
.su-bars span:nth-child(3) { animation-delay: 860ms; }
.su-bars span:nth-child(4) { animation-delay: 940ms; }
.su-bars span:nth-child(5) { animation-delay: 1020ms; }
.su-bars span:nth-child(6) { animation-delay: 1100ms; }
.su-bars .su-bar-hot { background: linear-gradient(180deg, var(--violet), var(--indigo)); }
@keyframes su-bar-in { from { transform: scaleY(0); } to { transform: scaleY(1); } }

/* People / avatars */
.su-avatars { display: flex; flex: 0 0 auto; }
.su-avatar {
  width: 38px; height: 38px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font: 600 0.72rem var(--font-body);
  color: #fff;
  border: 2px solid rgba(14,20,32,0.9);
  margin-left: -9px;
}
.su-avatar:first-child { margin-left: 0; }
.su-avatar-more { background: rgba(255,255,255,0.16); }

/* ---------------- Form panel ---------------- */
.su-form-panel {
  position: relative;
  flex: 1 1 52%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  overflow: hidden;
}
.su-form-bg {
  position: absolute; inset: 0;
  background:
    radial-gradient(48% 40% at 88% 6%, rgba(67,83,255,0.10) 0%, transparent 100%),
    radial-gradient(40% 34% at 6% 96%, rgba(23,195,162,0.10) 0%, transparent 100%),
    radial-gradient(rgba(14,20,32,0.05) 1px, transparent 1px);
  background-size: auto, auto, 26px 26px;
  pointer-events: none;
}
.su-form-inner {
  position: relative;
  width: 100%;
  max-width: 420px;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 2.4rem 2.2rem;
  box-shadow: 0 24px 60px rgba(14,20,32,0.10), 0 2px 8px rgba(14,20,32,0.05);
  opacity: 0;
  transform: translateY(14px);
  transition: opacity 500ms ease, transform 500ms ease;
}
.su-mounted .su-form-inner { opacity: 1; transform: translateY(0); }

.su-form-logo { display: none; height: 40px; margin-bottom: 1.5rem; }
.su-form-title {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 1.9rem;
  letter-spacing: -0.015em;
  margin: 0 0 0.4rem;
}
.su-form-sub { color: var(--ink-soft); font-size: 0.95rem; margin: 0 0 2rem; }

.su-alert {
  padding: 0.85rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  line-height: 1.45;
  margin-bottom: 1.4rem;
  border: 1px solid transparent;
}
.su-alert-error   { background: #FCEEEE; color: #9E2B2B; border-color: #F2CFCF; }
.su-alert-success { background: #E9F9F4; color: #0E7A64; border-color: #C4EDE1; }

.su-form { display: flex; flex-direction: column; gap: 1.35rem; }
.su-field { display: flex; flex-direction: column; }
.su-label-row { display: flex; justify-content: space-between; align-items: baseline; }
.su-label {
  font-size: 0.84rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  margin-bottom: 0.45rem;
  color: var(--ink);
}
.su-input-wrap { position: relative; }
.su-input-icon {
  position: absolute;
  left: 0.85rem; top: 50%;
  transform: translateY(-50%);
  width: 18px; height: 18px;
  color: #97A0B3;
  pointer-events: none;
  transition: color 160ms ease;
}
.su-input-icon svg { width: 100%; height: 100%; display: block; }
.su-input-wrap:focus-within .su-input-icon { color: var(--indigo); }
.su-input {
  width: 100%;
  padding: 0.8rem 0.95rem;
  font-size: 0.98rem;
  font-family: var(--font-body);
  color: var(--ink);
  background: #fff;
  border: 1.5px solid var(--line);
  border-radius: 10px;
  outline: none;
  transition: border-color 160ms ease, box-shadow 160ms ease;
  box-sizing: border-box;
}
.su-input-iconed { padding-left: 2.6rem; }
.su-input::placeholder { color: #A7AFC0; }
.su-input:hover { border-color: #C3C9D6; }
.su-input:focus {
  border-color: var(--indigo);
  box-shadow: 0 0 0 3px rgba(67,83,255,0.14);
}
.su-toggle-pw {
  position: absolute;
  right: 0.6rem; top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  font: 600 0.78rem var(--font-body);
  color: var(--ink-soft);
  cursor: pointer;
  padding: 0.35rem 0.5rem;
  border-radius: 6px;
}
.su-toggle-pw:hover { color: var(--indigo); background: rgba(67,83,255,0.07); }

.su-strength-track {
  height: 4px;
  border-radius: 2px;
  background: var(--line);
  margin-top: 0.6rem;
  overflow: hidden;
}
.su-strength-bar { height: 100%; width: 0; border-radius: 2px; transition: width 300ms ease, background 300ms ease; }
.su-strength-bar.su-strength-1 { width: 33%;  background: var(--red); }
.su-strength-bar.su-strength-2 { width: 66%;  background: var(--amber); }
.su-strength-bar.su-strength-3 { width: 100%; background: var(--teal); }
.su-strength-label { font-size: 0.76rem; font-weight: 600; }
.su-strength-label.su-strength-1 { color: var(--red); }
.su-strength-label.su-strength-2 { color: #B57A1E; }
.su-strength-label.su-strength-3 { color: #0E8A72; }
.su-hint { font-size: 0.78rem; color: var(--ink-soft); margin: 0.45rem 0 0; line-height: 1.4; }

.su-submit {
  margin-top: 0.4rem;
  padding: 0.9rem 1rem;
  font: 600 1rem var(--font-body);
  color: #fff;
  background: linear-gradient(135deg, var(--indigo) 0%, var(--violet) 100%);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  transition: filter 160ms ease, transform 120ms ease, box-shadow 160ms ease;
}
.su-submit:hover:not(:disabled) {
  filter: brightness(0.94);
  box-shadow: 0 6px 18px rgba(67,83,255,0.32);
  transform: translateY(-1px);
}
.su-submit:active:not(:disabled) { transform: translateY(0); }
.su-submit:disabled { opacity: 0.55; cursor: not-allowed; }
.su-submit:focus-visible,
.su-input:focus-visible,
.su-toggle-pw:focus-visible,
.su-link:focus-visible {
  outline: 2px solid var(--indigo);
  outline-offset: 2px;
}

.su-spinner {
  width: 18px; height: 18px;
  border: 2.5px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: su-spin 0.8s linear infinite;
}
@keyframes su-spin { to { transform: rotate(360deg); } }

.su-footer {
  margin-top: 1.8rem;
  text-align: center;
  font-size: 0.9rem;
  color: var(--ink-soft);
}
.su-link { color: var(--indigo); font-weight: 600; text-decoration: none; }
.su-link:hover { text-decoration: underline; }

/* ---------------- Responsive ---------------- */
@media (max-width: 1180px) {
  .su-brand-content, .su-cards { padding-left: 2.5rem; padding-right: 2.5rem; }
}
@media (max-width: 900px) {
  .su-brand { display: none; }
  .su-form-logo { display: block; }
  .su-form-panel { padding: 2.5rem 1.25rem; }
  .su-form-inner { padding: 2rem 1.5rem; }
}

/* ---------------- Reduced motion ---------------- */
@media (prefers-reduced-motion: reduce) {
  .su-form-inner { transition: none; opacity: 1; transform: none; }
  .su-orb { animation: none; }
  .su-card { animation: none; opacity: 1; transform: none; }
  .su-bars span { animation: none; }
  .su-ring-fill { animation: none; stroke-dashoffset: 9.6; }
  .su-strength-bar, .su-input, .su-submit { transition: none; }
}
`;

export default SignUp;